'use client';

import Image from 'next/image';
import React, { Dispatch, SetStateAction } from 'react';
import toast from 'react-hot-toast';

interface TopPageProps {
  title: string;
  isLogged: boolean;
  isMaxSm: boolean;
  setSaveModalOpen: Dispatch<SetStateAction<boolean>>;
}

export function TopPageComponent({ title, isLogged, isMaxSm, setSaveModalOpen }: TopPageProps) {
  const onSaveSearch = () => {
    if (!isLogged) {
      return toast.error('Please login or sign up to save your search');
    }

    setSaveModalOpen(true);
  };

  return (
    <div className='flex flex-col md:flex-row md: gap-4 items-center justify-between mb-5'>
      <h2 className='text-[1.5rem] md:text-[2.5rem] lg:text-[2.5rem] font-bold lg:mb-1 text-center md:text-left'>
        {title} Vehicles for Sale
      </h2>
      {!isMaxSm && (
        <div>
          <button
            type='button'
            onClick={onSaveSearch}
            className='relative font-bold rounded-[6px] bg-primary text-background uppercase
              flex items-center gap-4 md:gap-10 px-4 md:px-5 py-2 md:py-[0.75rem]
              hover:text-background! hover:bg-primary-3 transition-all duration-300'
          >
            <span className='whitespace-nowrap'>Save your Search</span>
            <Image src='/images/icon/plus-white.png' width={17} height={17} alt='' />
          </button>
        </div>
      )}
    </div>
  );
}

export const TopPage = React.memo(TopPageComponent);
